import formatDate from '@/services/general/formatIsoDate';

export function postGetData(marche) {
  if (marche.dateSignature) marche.dateSignature = new Date(marche.dateSignature);
  if (marche.dateDebut) marche.dateDebut = new Date(marche.dateDebut);
  if (marche.dateFin) marche.dateFin = new Date(marche.dateFin);
  marche.produits.forEach(p => {
    p.selected = false;
  });
  return marche;
}
export function preSaveOrUpdateData(marche) {
  if (marche.dateSignature) marche.dateSignature = formatDate(marche.dateSignature);
  if (marche.dateDebut) marche.dateDebut = formatDate(marche.dateDebut);
  if (marche.dateFin) marche.dateFin = formatDate(marche.dateFin);
}
